import { render, staticRenderFns } from "./ThgAdvertisementDetail.vue?vue&type=template&id=58cc0863&"
import script from "./ThgAdvertisementDetail.vue?vue&type=script&lang=ts&"
export * from "./ThgAdvertisementDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports